/** sessionStorage key prefixes used by Features draft persistence (must stay in sync with Features). */
export const UNSAVED_FEATURES_NEW_ROWS_PREFIX = 'features:new-rows:';
export const UNSAVED_FEATURES_CHANGES_PREFIX = 'features:changes:';

const isUnsavedFeaturesKey = (key: string): boolean =>
  key.startsWith(UNSAVED_FEATURES_NEW_ROWS_PREFIX) ||
  key.startsWith(UNSAVED_FEATURES_CHANGES_PREFIX);

/**
 * Returns true if sessionStorage has non-empty feature draft rows or change maps.
 * Same logic previously inlined in SlideOutPanel close / unsaved checks.
 */
export const hasUnsavedFeaturesInSessionStorage = (): boolean => {
  try {
    const keys = Object.keys(sessionStorage);

    for (const key of keys) {
      if (!isUnsavedFeaturesKey(key)) {
        continue;
      }

      const value = sessionStorage.getItem(key);
      if (!value) {
        continue;
      }

      try {
        const parsed = JSON.parse(value);
        if (key.startsWith(UNSAVED_FEATURES_NEW_ROWS_PREFIX)) {
          if (Array.isArray(parsed) && parsed.length > 0) {
            return true;
          }
        } else if (key.startsWith(UNSAVED_FEATURES_CHANGES_PREFIX)) {
          if (
            parsed &&
            typeof parsed === 'object' &&
            Object.keys(parsed).length > 0
          ) {
            return true;
          }
        }
      } catch {
        // Invalid JSON — skip
      }
    }

    return false;
  } catch {
    return false;
  }
};

/** Removes all feature draft keys from sessionStorage (e.g. on confirmed close). */
export const clearUnsavedFeaturesFromSessionStorage = (): void => {
  try {
    const keys = Object.keys(sessionStorage);
    keys.forEach(key => {
      if (isUnsavedFeaturesKey(key)) {
        sessionStorage.removeItem(key);
      }
    });
  } catch (e) {
    console.error('Failed to clear feature storage:', e);
  }
};
